import { PenaltySetting } from "../../classes"
const PenaltySettingModule = {
  namespaced: true,
  actions: {
    createPenaltySetting: async ({ commit }, formData) => {
      try {
        const penaltySetting = await PenaltySetting.createPenaltySetting(formData)
        return penaltySetting
      } catch (error) {
        throw error
      }
    },
    updatePenaltySetting: async ({ commit }, formData) => {
      try {
        const penaltySetting = await PenaltySetting.updatePenaltySetting(formData)
        return penaltySetting
      } catch (error) {
        throw error
      }
    },
    getPenaltySettingByMarket: async ({ commit }, formData) => {
      try {
        const penaltySetting = await PenaltySetting.getPenaltySettingByMarket(formData)
        return penaltySetting
      } catch (error) {
        throw error
      }
    },
  },
  getters: {},
};
export default PenaltySettingModule;
